export default function ArchivedIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.8125 3.0625V12.625C0.8125 12.7742 0.871763 12.9173 0.977253 13.0227C1.08274 13.1282 1.22582 13.1875 1.375 13.1875H12.625C12.7742 13.1875 12.9173 13.1282 13.0227 13.0227C13.1282 12.9173 13.1875 12.7742 13.1875 12.625V3.0625M0.8125 3.0625L1.9375 0.8125H12.0625L13.1875 3.0625M0.8125 3.0625H13.1875M4.61352 8.55102L7 10.9375M7 10.9375L9.38648 8.55102M7 10.9375V5.3125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
